export const MARKER_POPUP_OPEN_DELAY = 750;
export const MARKER_POPUP_CLOSE_DELAY = 1000;
